import { FormItem as AntdFormItem } from "@empglabs/backoffice-ui-kit"

const FormItem = props => {
  return <AntdFormItem {...props} />
}

export default FormItem
